import "moment-timezone";
import moment from "moment";
import IConfigDatetime from "../interface/field-cfg-datetime";

export default class DateFilterValue {

    public readonly start: number;

    public readonly end: number;

    public readonly dateISO: string;

    constructor(iso: string, config: IConfigDatetime, minOnly: boolean = false, maxOnly: boolean = false) {
        const minTime: string = 'T00:00:00.000';
        const maxTime: string = 'T23:59:59.999';
        const minString: string = maxOnly ? `${iso}${maxTime}` : `${iso}${minTime}`;
        const maxString: string = minOnly ? `${iso}${minTime}` : `${iso}${maxTime}`;
        let minMoment: moment.Moment;
        let maxMoment: moment.Moment;
        if (config.timezone) {
            minMoment = moment.tz(minString, config.timezone);
            maxMoment = moment.tz(maxString, config.timezone);
        } else {
            minMoment = moment(minString);
            maxMoment = moment(maxString);
        }
        this.dateISO = iso;
        this.start = minMoment.unix();
        this.end = maxMoment.unix();
    }

}